export {FileTrigger} from 'react-aria-components/FileTrigger';
export type {FileTriggerProps} from 'react-aria-components/FileTrigger';
